/**
 * Otočení fotografie uložené v Supabase Storage o 90° doprava.
 * Stáhne obrázek, otočí ho přes canvas a nahraje zpět na stejné místo.
 */
import { supabase } from './supabase.js';

function blobToImage(blob) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        const u = URL.createObjectURL(blob);
        img.onload = () => { URL.revokeObjectURL(u); resolve(img); };
        img.onerror = () => { URL.revokeObjectURL(u); reject(new Error('Obrázek se nepodařilo načíst.')); };
        img.src = u;
    });
}

/**
 * @param {string} bucket    - název úložiště
 * @param {string} path      - cesta k souboru v úložišti
 * @param {string} sourceUrl - funkční URL pro stažení obrázku (signed nebo public)
 */
export async function rotateStoredImage(bucket, path, sourceUrl) {
    // no-store — ať se po opakovaném otočení nestáhne stará verze z cache
    const resp = await fetch(sourceUrl, { cache: 'no-store' });
    if (!resp.ok) throw new Error('Soubor se nepodařilo stáhnout.');
    const img = await blobToImage(await resp.blob());

    // Otočení o 90° doprava — rozměry se prohodí.
    const canvas = document.createElement('canvas');
    canvas.width = img.naturalHeight;
    canvas.height = img.naturalWidth;
    const ctx = canvas.getContext('2d');
    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate(Math.PI / 2);
    ctx.drawImage(img, -img.naturalWidth / 2, -img.naturalHeight / 2);

    const rotated = await new Promise((res) => canvas.toBlob(res, 'image/jpeg', 0.92));
    if (!rotated) throw new Error('Otočení se nezdařilo.');

    const { error } = await supabase.storage.from(bucket).upload(path, rotated, {
        upsert: true,
        contentType: 'image/jpeg',
        cacheControl: '3600'
    });
    if (error) throw error;
}
